import { motion } from "framer-motion";
import { Section, GridContainer } from "../layout";
import { Button, HeroScreenshot } from "../ui";
import { staggerContainer, staggerItem, scaleFade } from "../shared";

const benefits = [
  "Más volumen con el mismo equipo",
  "Cálculos y contratos automatizados",
  "Compliance integrado desde el diseño",
];

/**
 * Hero section with Mintlify-style layout.
 * Centered text content with screenshot below.
 */
export function Hero() {
  const handleScrollToProducto = () => {
    const element = document.getElementById("producto");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Section id="hero" size="lg" noPaddingBottom className="relative z-10 overflow-hidden">
      {/* Ambient blob — oversized, blurred, right-aligned */}
      <img
        src="/assets/auth0-bg.svg"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute top-[50%] -translate-y-1/2 -right-[10%] w-[700px] h-[700px] opacity-40"
        style={{ filter: "blur(140px)" }}
      />

      <GridContainer>
        {/* Centered text content */}
        <motion.div
          className="col-span-4 md:col-span-8 xl:col-span-12 flex flex-col items-center text-center"
          variants={staggerContainer}
          initial="hidden"
          animate="visible"
        >
          {/* H1 - pyramid structure (short line, then longer) */}
          <motion.h1
            className="text-h1-mobile md:text-h1-tablet xl:text-h1 text-text-primary"
            variants={staggerItem}
          >
            <span className="block">Gestiona el</span>
            <span className="block">incentivo fiscal sin caos</span>
          </motion.h1>

          {/* Tagline - two lines of equal width */}
          <motion.p className="mt-6 text-body text-text-secondary max-w-md" variants={staggerItem}>
            <span className="block">La plataforma para estructuradores</span>
            <span className="block">que profesionaliza la gestión del Art. 39.7</span>
          </motion.p>

          {/* Benefits - horizontal (hidden on mobile) */}
          <motion.div
            className="hidden md:flex mt-8 flex-row items-start gap-20"
            variants={staggerItem}
          >
            {benefits.map((label) => (
              <div key={label} className="flex items-start gap-2 max-w-[180px]">
                <img src="/icons/stick.svg" alt="" className="w-5 h-5 shrink-0 mt-0.5" />
                <p className="text-sm font-medium text-text-tertiary text-left">{label}</p>
              </div>
            ))}
          </motion.div>

          {/* CTAs */}
          <motion.div
            className="mt-8 md:mt-10 flex flex-col md:flex-row items-stretch md:items-center justify-center gap-3 md:gap-4"
            variants={staggerItem}
          >
            <a href="/contact">
              <Button variant="primary" className="w-full md:w-auto">
                Book Demo
              </Button>
            </a>
            <Button
              variant="ghost"
              onClick={handleScrollToProducto}
              className="group justify-center md:justify-start"
            >
              Ver cómo funciona
              <span className="inline-block ml-2 group-hover:animate-bounce">↓</span>
            </Button>
          </motion.div>
        </motion.div>

        {/* Screenshot - full width below with scale entrance */}
        <motion.div
          className="col-span-4 md:col-span-8 xl:col-span-12 mt-8 md:mt-12 xl:mt-16"
          variants={scaleFade}
          initial="hidden"
          animate="visible"
          transition={{ delay: 0.6 }}
        >
          <HeroScreenshot
            src="/screenshots/dashboard-hero.png"
            alt="Dashboard de Hulahoop Pro mostrando métricas de inversiones culturales"
          />
        </motion.div>
      </GridContainer>
    </Section>
  );
}
